<template>
  <Custom-Select
    :label="label"
    v-model="list"
    :items="dictionariesGetter"
    :multiple="multiple"
  />
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Dictionaries',
  components: {},

  props: {
    value: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters({
      dictionariesGetter: 'projects/dictionaries',
    }),

    list: {
      get() {
        return this.value
      },
      set(item) {
        this.$emit('input', item)
      },
    },
  },

  methods: {
    ...mapActions({
      loadDictionaries: 'projects/loadDictionaries',
    }),
  },

  async mounted() {
    this.loadDictionaries()
  },
}
</script>